import { Controller, Toolbar, Menu } from '@tencent/workbench';
import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
import { VipServiceFeature } from './vip-service-feature';
import { MENU_CONFIGS, moreVipPrivilegesConfig, TOOLBAR_ITEMS, vipServiceConfig } from './config';
import { vipTabReport } from './report';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';
import { VIP_MENU } from '../single-menu/config';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class VipServiceController {
    public constructor(private readonly feature: VipServiceFeature) {
        vipTabReport('tool_tab', 'show');
    }

    @Toolbar(vipServiceConfig.id, 'onClick')
    public async clickVipService() {
        tencentDocOpenUrlForAll({
            url: `${location.protocol}//${location.host}/vip?aid_position=toolbarviptab&from_entry=vipcenter`,
            replace: false,
        });
    }

    @Toolbar(moreVipPrivilegesConfig.id, 'onClick')
    @Menu(moreVipPrivilegesConfig.id, 'onClick')
    public clickMoreVipPrivileges() {
        tencentDocOpenUrlForAll({
            url: `${location.protocol}//${location.host}/vip?aid_position=toolbarviptab&from_entry=vipcenter`,
            replace: false,
        });
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_VIP, 'onClick')
    @Menu(VIP_MENU, 'onClick')
    public onVipServiceClick() {
        vipTabReport('tool_tab', 'click');
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_VIP, 'shouldHide')
    @Menu(VIP_MENU, 'shouldHide')
    public shouldHide() {
        // saas没有vip
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.toolbarVip as any) ?? true);
    }
}
